import { GET_ALL_CATEGORY } from "../const";
export const getCategory = (data: any) => {
    return {
        type: GET_ALL_CATEGORY,
        payload: data,
    };
};
